webpackJsonpUpdateBris([92],{

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.KlevuSearch = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = __webpack_require__(4);

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NS = 'KlevuSearch';
var CLS = 'klevuSearch';
var BLK = '.' + CLS + '-';

var KlevuSearch = exports.KlevuSearch = function () {
	function KlevuSearch(el) {
		_classCallCheck(this, KlevuSearch);

		this.el = el;
		this.$el = $(el);
		this.$searchInput = this.$el.find('.' + CLS + '-input');
		this.$target = this.$el.find('.' + CLS + '-target');
		this.$closeBtn = this.$el.find('.' + CLS + '-closeBtn');

		this.apiKey = this.$el.data('apiKey');
		this.searchUrl = this.$el.data('searchUrl');
		this.landingPage = this.$el.data('landingPage');
	}

	_createClass(KlevuSearch, [{
		key: 'init',
		value: function init() {
			var _this = this;

			if (!klevu) return;

			klevu.interactive(function () {
				_this.klevuInit();
			});

			this.$closeBtn.on('click', function () {
				_this.closeQuickSearch();
				_this.$el.removeClass('klevuSearch--focus');
			});

			document.addEventListener('keyup', function (e) {
				if (e.key === "Escape") {
					// escape key maps to keycode `27`
					_this.closeQuickSearch();
					_this.$searchInput.trigger('blur');
				}
			});
		}

		// Klevu setting

	}, {
		key: 'klevuInit',
		value: function klevuInit() {
			var options = {
				url: {
					landing: this.landingPage,
					protocolFull: klevu.settings.url.protocol + "//",

					// replace this with your own API Endpoint,
					// and include 'v2' in the subdomain for best performance,
					// eg. https://eucs18v2.ksearchnet.com/cs/v2/search
					// search: klevu.settings.url.protocol + '//eucs26v2.ksearchnet.com/cs/v2/search',
					search: this.searchUrl
				},
				localSettings: true,
				search: {
					minChars: 0,
					searchBoxSelector: '#' + this.$searchInput.attr('id'),

					// replace this with your own JS API Key
					apiKey: this.apiKey,
					searchBoxTarget: this.$target[0]
				},
				analytics: {
					apiKey: this.apiKey
				}
			};
			if ($('.siteHeader').hasClass('desktop-menu-2022')) {
				if (utils.isOnMobile() && this.$searchInput.attr('id') === 'klevuSearch-input-desktop' || !utils.isOnMobile() && this.$searchInput.attr('id') === 'klevuSearch-input-mobile') {
					return;
				}
			}
			klevu(options);

			//check if klevu is interactive and also if all necessary search instances are powered up
			klevu.coreEvent.build({
				name: "bindLocalBoxes",
				fire: function fire() {
					if (!klevu.isInteractive || klevu.isUndefined(klevu.search) || klevu.isUndefined(klevu.search.build) || klevu.isUndefined(klevu.searchEvents) || klevu.isUndefined(klevu.searchEvents.functions) || klevu.isUndefined(klevu.searchEvents.functions.bindAllSearchBoxes)) {
						return false;
					}
					return true;
				},
				maxCount: 500,
				delay: 30
			});

			//attach to all search boxes on the page
			klevu.coreEvent.attach("bindLocalBoxes", {
				name: "search-boxes-local-boxes",
				fire: function fire() {
					klevu.searchEvents.functions.bindAllSearchBoxes.fire();
				}
			});
		}
	}, {
		key: 'closeQuickSearch',
		value: function closeQuickSearch() {
			klevu.each(klevu.search.extraSearchBox, function (key, box) {
				var fullPage = klevu.getSetting(box.getScope().settings, "settings.search.fullPageLayoutEnabled", true);
				if (!fullPage) {
					var target = klevu.getSetting(box.getScope().settings, "settings.search.searchBoxTarget");
					target.style = "display: none !important;";
				}
			});
		}
	}]);

	return KlevuSearch;
}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ })

});


// WEBPACK FOOTER //
// 1742452116000.blk-klevu-search-chunk.js